import { useState } from "react";
import { FileText } from "lucide-react";
import { toast } from "sonner";
import { useUnit } from "@/context/UnitContext";
import { useLayout } from "@/context/LayoutContext";
import { useAuth } from "@/context/AuthContext";
import { exportRecipesPdf } from "@/lib/recipePdf";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button, Segmented } from "@/components/kit";

const OPTIONS = [
  { value: "kitchen", label: "Cozinha (sem valores)" },
  { value: "costs", label: "Completa com custos" },
];

export default function PrintDialog({ open, onOpenChange, recipes }) {
  const { isMgmt } = useAuth();
  const { unit } = useUnit();
  const { layout } = useLayout();
  const [mode, setMode] = useState("kitchen");
  const go = () => {
    if (!exportRecipesPdf(recipes, { withCosts: isMgmt && mode === "costs", unitName: unit?.name, appName: layout?.app_name })) return toast.error("Não foi possível gerar o PDF");
    onOpenChange(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="recipe-print-dialog">
        <DialogTitle>Imprimir {recipes.length === 1 ? "ficha técnica" : `${recipes.length} fichas técnicas`}</DialogTitle>
        <DialogDescription>Abre uma página pronta para imprimir ou salvar em PDF · uma ficha por página.</DialogDescription>
        {isMgmt && <Segmented options={OPTIONS} value={mode} onChange={setMode} testid="recipe-print-mode" />}
        <p className="caption">{isMgmt && mode === "costs" ? "Inclui custos por insumo, CMV teórico, margem e preço sugerido · ideal para arquivo e contador." : "Só ingredientes, quantidades, preparo e empratamento · para deixar na cozinha."}</p>
        <Button icon={FileText} onClick={go} disabled={!recipes.length} data-testid="recipe-print-confirm-button">Gerar PDF</Button>
      </DialogContent>
    </Dialog>
  );
}
